import {
  getOrganizationQueryOptions,
  getSessionQueryOptions,
} from "@/api/get-workspace";
import { useQuery } from "@tanstack/react-query";

/**
 * Who is signed in and which organization Beam is reading from. Both the header
 * and the prompt placeholder need this; React Query serves them from one cache
 * entry rather than two reads.
 */
export function useWorkspaceIdentity(): {
  organizationName: string | undefined;
  organizationLogoUrl: string | null | undefined;
  firstName: string | undefined;
} {
  const { data: session } = useQuery(getSessionQueryOptions());
  const organizationId = session?.organization_id;
  const firstName = session?.account.full_name?.trim().split(/\s+/)[0];

  const { data: organization } = useQuery({
    ...getOrganizationQueryOptions(organizationId ?? ""),
    enabled: !!organizationId,
  });

  return {
    organizationName: organization?.data.name,
    organizationLogoUrl: organization?.data.logo_url,
    firstName: session ? firstName || "Account" : undefined,
  };
}
